export default __webpack_public_path__ + "static/media/tavi_small@2x.f3f78561.jpg";